<div class="site-footer">
    <img 
        src="/assets/img/indigital.png" 
        alt="INDIGITAL"
    >
    <p class="site-footer__text">
        INDIGITAL {{ anio }} &copy; Todos los derechos reservados. V1.0.1
    </p>
</div>
